// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsWinnersSetBody = {
  poolId: string;
  eventId: string;
  stripNumber: number;
  row: number;
  winners: { stripWinnerId: string | null; wonAt: string; note: string }[];
};

export type typeStripsWinnersSetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    winners: { stripWinnerId: string; wonAt: string; note: string }[];
    addedCount: number;
    removedCount: number;
  };
};

export type typeStripsWinnersSetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsWinnersSetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsWinnersSetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsWinnersSetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    stripNumber: { type: "integer" },
    row: { type: "integer" },
    winners: {
      type: "array",
      items: {
        type: "object",
        properties: {
          stripWinnerId: {
            oneOf: [
              { type: "string", maxLength: 3000, minLength: 1 },
              { enum: [null] },
            ],
          },
          wonAt: { type: "string", maxLength: 3000, minLength: 1 },
          note: { type: "string", maxLength: 3000, minLength: 0 },
        },
        required: ["stripWinnerId", "wonAt", "note"],
      },
    },
  },
  required: ["poolId", "eventId", "stripNumber", "row", "winners"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsWinnersSet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsWinnersSetBody);
  }

  return async function postStripsWinnersSet(
    payload: typeStripsWinnersSetBody,
  ): Promise<typeStripsWinnersSetOutput200 | typeStripsWinnersSetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsWinnersSet" failed before calling the network. #620102bf597a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#620102bf597a" },
        },
        data: null,
      } as typeStripsWinnersSetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/winners-set`,
      httpMethod: "POST",
      options,
    })) as typeStripsWinnersSetOutput200 | typeStripsWinnersSetOutput400;
  };
}
